module.exports = __webpack_public_path__ + "img/tiktok_icon.3ada47e4.svg";